/*-----------------------------------------------------------------
- Footer
-----------------------------------------------------------------*/
export default {
    contact_title   : 'Ways to communicate with us',
    socials_title   : 'Follow us on social networks',
    trust_seal_title: 'Safely trust us',
    powered_by_text : 'Powered by Quarkino',
    show_on_map     : 'Show our address on map',
};
